import {SubmitMissionProgressResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {MissionType} from '../utils/missionType';

const missionConfigs: Record<
  MissionType,
  {
    missionTitle: string;
    reward: number;
    congratulationTitle: string;
    congratulationDescription: string;
  }
> = {
  addBirthdayMission: {
    missionTitle: 'Add your birthday',
    reward: 100,
    congratulationTitle: 'Congrats 🎉',
    congratulationDescription:
      "You've added your birthday! Get bonus coins now and a gift on your day.",
  },
  pushNotificationMission: {
    missionTitle: 'Enable push notifications',
    reward: 200,
    congratulationTitle: 'Awesome! 🎊',
    congratulationDescription:
      "You've enabled push notifications! Stay updated on deals and order updates.",
  },
  newsletterMission: {
    missionTitle: 'Join our newsletter',
    reward: 150,
    congratulationTitle: 'Welcome! 🎈',
    congratulationDescription:
      "You've joined our newsletter! Get exclusive deals and bonus coins.",
  },
  likeBrandMission: {
    missionTitle: 'You liked 3 brands!',
    reward: 50,
    congratulationTitle: 'Nice! 🎉',
    congratulationDescription:
      "You've liked a brand! Discover more favorites and earn coins.",
  },
};

export const submitMissionProgress = (
  missionType: MissionType = 'addBirthdayMission',
): SubmitMissionProgressResponse => {
  const config = missionConfigs[missionType];

  return {
    missionSuccessNotification: {
      title: 'Mission',
      missionStage: {
        title: config.missionTitle,
      },
      congratulationsStage: {
        title: config.congratulationTitle,
        description: config.congratulationDescription,
        reward: config.reward,
      },
    },
  };
};
